// src/utils/device.ts
export function isMobileDevice() {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent || '';
  const isMobileUA = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  const isSmallWidth = window.innerWidth <= 768;
  return isMobileUA || isSmallWidth;
}
